// CrossSelling – wiederverwendbarer Block für Barometer-Unterseiten
// Zeigt 2-3 passende Ergänzungsprodukte mit Preis und CTA

interface CrossSellingItem {
  icon: string;
  title: string;
  description: string;
  price: string;
  href: string;
  accent: string;
  badge?: string; // z.B. "Bestseller" oder "Neu"
}

interface CrossSellingProps {
  items: CrossSellingItem[];
  headline?: string;
  subline?: string;
}

export function CrossSelling({
  items,
  headline = "Das passt dazu",
  subline = "Kombiniere mehrere Barometer für das vollständige Bild deines Marketings.",
}: CrossSellingProps) {
  return (
    <section className="w-full bg-[#f2f2f2] py-16 px-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <p
            className="text-xs font-bold tracking-widest uppercase mb-2"
            style={{ color: "#6d0000", fontFamily: "'DM Sans', sans-serif" }}
          >
            Marketing Barometer Suite
          </p>
          <h2
            className="font-black uppercase leading-none text-black mb-3"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(2rem, 6vw, 3rem)" }}
          >
            {headline}
          </h2>
          <p className="text-gray-500 text-sm max-w-xl" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            {subline}
          </p>
        </div>

        {/* Karten */}
        <div className={`grid gap-4 ${items.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3"}`}>
          {items.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="group flex flex-col bg-white border border-gray-200 overflow-hidden"
              style={{ textDecoration: "none", transition: "box-shadow 0.2s" }}
              onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.10)")}
              onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
            >
              {/* Akzentlinie */}
              <div className="h-1 w-full" style={{ backgroundColor: item.accent }} />

              <div className="p-6 flex flex-col flex-1">
                {/* Icon + Badge */}
                <div className="flex items-start justify-between mb-4">
                  <img src={item.icon} alt="" className="w-9 h-9 object-contain flex-shrink-0" style={{ opacity: 0.85 }} />
                  {item.badge && (
                    <span
                      className="text-xs font-bold uppercase tracking-widest px-2 py-1"
                      style={{ backgroundColor: item.accent, color: "#fff", fontFamily: "'DM Sans', sans-serif" }}
                    >
                      {item.badge}
                    </span>
                  )}
                </div>

                {/* Titel */}
                <h3
                  className="font-black uppercase leading-none mb-2 text-black"
                  style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "1.5rem" }}
                >
                  {item.title}
                </h3>

                {/* Beschreibung */}
                <p
                  className="text-gray-500 text-sm leading-relaxed flex-1 mb-4"
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                >
                  {item.description}
                </p>

                {/* Preis + CTA */}
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100">
                  <div>
                    <span className="text-xs text-gray-400 uppercase tracking-widest block" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                      Vollversion
                    </span>
                    <span
                      className="font-black text-xl"
                      style={{ color: item.accent, fontFamily: "'Bebas Neue', sans-serif" }}
                    >
                      {item.price}
                    </span>
                  </div>
                  <span
                    className="text-xs font-bold uppercase tracking-widest px-4 py-2 text-white"
                    style={{ backgroundColor: item.accent, fontFamily: "'DM Sans', sans-serif" }}
                  >
                    Kostenlos testen →
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
